import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Interstellar() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Interstellar</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>A breathtaking piano cover of Hans Zimmer's iconic film score.</p>
          <div style={{ width: 340, height: 191, marginBottom: 24, borderRadius: 24, overflow: "hidden", boxShadow: "0 4px 32px rgba(0,0,0,0.10)" }}>
            <iframe
              width="340"
              height="191"
              src="https://www.youtube.com/embed/LSe4ZMajYJ4"
              title="Interstellar Piano Cover"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: 24, width: "100%", height: "100%" }}
            ></iframe>
          </div>
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            "Interstellar" by Hans Zimmer is a majestic, emotional theme that translates beautifully to piano. Watch the video above!
          </div>
        </section>
        {/* About this song section */}
        <section style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "40px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>About this song</h2>
            <p style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7 }}>
              "Interstellar" is the main theme from Christopher Nolan's 2014 film, composed by Hans Zimmer. Its soaring organ and piano melodies capture the wonder and vastness of space, making it a beloved piece for piano performances.
            </p>
            <ul style={{ fontSize: "1.05rem", color: "#555", marginTop: 18, marginLeft: 18 }}>
              <li>Released: 2014</li>
              <li>Film: Interstellar</li>
              <li>Genre: Film Score, Orchestral</li>
              <li>Composer: Hans Zimmer</li>
            </ul>
          </div>
        </section>
        {/* Fun facts / fill space visually */}
        <section style={{
          marginTop: 64,
          background: "rgba(255,255,255,0.7)",
          borderRadius: 32,
          maxWidth: 1100,
          marginLeft: "auto",
          marginRight: "auto",
          padding: "36px 32px 32px 32px",
          boxShadow: "0 2px 24px rgba(30,60,120,0.07)",
          display: "flex",
          flexDirection: "row",
          gap: 48,
          alignItems: "center",
          justifyContent: "center"
        }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 10 }}>Did you know?</h3>
            <ul style={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Hans Zimmer composed the score using a church pipe organ.</li>
              <li>The soundtrack was nominated for an Academy Award.</li>
              <li>The piano arrangement brings out the theme's emotional depth.</li>
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 260, textAlign: "center" }}>
            <ImageWithFallback src="/profile.png" alt="Artist" style={{ width: 120, borderRadius: "50%", marginBottom: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.10)" }} />
            <div style={{ color: "#1976d2", fontWeight: 500, fontSize: "1.1rem" }}>Explore more piano covers on this site!</div>
          </div>
        </section>
        {/* Try Another Song / Request a Song section */}
        <section style={{
          background: "rgba(255,255,255,0.8)",
          borderRadius: 32,
          maxWidth: 900,
          margin: "48px auto 0 auto",
          padding: "40px 32px 32px 32px",
          boxShadow: "0 2px 24px rgba(30,60,120,0.07)",
          display: "flex",
          flexDirection: "row",
          gap: 48,
          alignItems: "flex-start",
          justifyContent: "center"
        }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 18 }}>Try Another Song</h2>
            <ul style={{ color: "#444", fontSize: "1.1rem", lineHeight: 1.7, marginLeft: 18, marginBottom: 0 }}>
              <li><a href="/shapeofyou" style={{ color: "#1976d2", textDecoration: "none" }}>Shape of You</a> (Ed Sheeran)</li>
              <li><a href="/letmedownslowly" style={{ color: "#1976d2", textDecoration: "none" }}>Let Me Down Slowly</a> (Alec Benjamin)</li>
              <li><a href="/pasoori" style={{ color: "#1976d2", textDecoration: "none" }}>Pasoori</a> (Coke Studio)</li>
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 260, textAlign: "center" }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 18 }}>Request a Song</h2>
            <p style={{ color: "#444", fontSize: "1.1rem", lineHeight: 1.7 }}>
              Want to see your favorite song covered? <a href="mailto:your@email.com" style={{ color: "#1976d2", textDecoration: "underline" }}>Email me your request!</a>
            </p>
          </div>
        </section>
        <div style={{
            fontSize: "1.1rem",
            color: "#555",
            maxWidth: 600,
            textAlign: "center",
            marginTop: 24
          }}>
            <p>For inquiries, contact: <a href="mailto:vivaancode007@gmail.com">vivaancode007@gmail.com</a></p>
          </div>
      </main>
      <footer style={{
        backgroundColor: "#f8f9fa",
        padding: "20px 0",
        textAlign: "center",
        borderTop: "1px solid #e9ecef",
      }}>
        <div>
          <h4>Coding Projects</h4>
          <select style={{ padding: "10px", borderRadius: "5px" }}>
            <option value="games">Games</option>
            <option value="math">Math</option>
            <option value="drawing">Drawing</option>
          </select>
        </div>
        <div style={{ marginTop: "10px" }}>
          <a href="/terms-and-conditions">Terms & Conditions</a>
        </div>
      </footer>
    </>
  );
}

export default Interstellar;
